import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Footer from '@/components/Footer.vue';
import Drawer from '@/components/common/Drawer.vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { Actions } from './models/store.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'BazaarApp',
  setup(__props) {

const store = useStore();

onMounted(() => {
  store.dispatch(Actions.GetAuth);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("header", null, null, -1)),
    _createElementVNode("main", null, [
      _createVNode(_component_RouterView)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("footer", null, [
      _createVNode(Footer)
    ]),
    _createVNode(Drawer)
  ], 64))
}
}

})